import axios from 'axios';
import { API_URL } from '../constants';
import { getFirebaseIdToken } from '../auth';

async function authHeaders() {
    const token = await getFirebaseIdToken();
    return token
        ? { Authorization: `Bearer ${token}` }
        : {};  // return empty headers if no user
}

/**
 *  @param {string} itemID - the ID of the item to look up
    @param {string} itemType - the type of item to look up (e.g. 'groups', 'users', 'hearts')
 */
export const queryServer = async (itemID, itemType) => {
    try {
        const headers = await authHeaders();
        const response = await axios.get(`${API_URL}/${itemType}/${itemID}`, 
            {headers}
        );
        return response.data;
    } catch (error) {
        console.error('Error looking up the item:', error);
        throw error;
    }
};

/**
 * 
 * @param {string} itemType - the type of item to look up (e.g. 'groups', 'users', 'hearts')
 * @param {string} item - the item to create on the server
 * @returns - the server response (201 Created or 400 Bad Request)
 */
export const createItemOnServer = async (itemType, item) => {
    try {
        console.log("In createItemOnServer API call...", item);
        const headers = await authHeaders();
        const response = await axios.post(
            `${API_URL}/${itemType}`, 
            item, 
            {headers}
        );
        return response.data;
    } catch (error) {
        console.error('Error creating the heart:', error);
        throw error;
    }
};

// function to delete item on server
export const deleteItemOnServer = async (itemType, itemID) => {
    try {
        const headers = await authHeaders();;
        const response = await axios.delete(
            `${API_URL}/${itemType}`, 
            { 
                headers,
                data: { itemID: itemID } 
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error deleting the item:', error);
        throw error;
    }
};